import { render } from "./Home.vue?vue&type=template&id=97241d2c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=97241d2c&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Documents/Works/fast_energy_task_manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97241d2c"]])

export default __exports__